export const columns = [{
    id: 'picture',
    title: '图片',
    field: 'imageUrl',
    fixed: 'left',
    width: '90px',
    slots: {
      default: 'image'
    },
    default: true,
    disabled: true,
    // treeNode: true,
  },
  {
    id: 'sku',
    title: '产品名称/SKU',
    field: 'skuNameAndSku',
    fixed: 'left',
    minWidth: '150px',
    default: true,
    disabled: true,
    slots: {
      default: 'skuNameAndSku'
    },
    sortable: true,
    sortBy:'sku'
  },
  {
    id: 'msku',
    title: 'MSKU',
    field: 'msku',
    minWidth: '180px',
    slots: {
      default: 'msku'
    },
    default: true,
    sortable: true
  },
  {
    id: 'category',
    title: '品类',
    field: 'categoryName',
    minWidth: '100px',
    default: true,
    sortable: true,
    sortBy:'categoryId'
  },
  {
    id: 'brand',
    title: '品牌',
    field: 'brandName',
    minWidth: '100px',
    default: true,
    sortable: true,
    sortBy: 'brandId'
  },
  {
    id: 'unitsOrdered',
    title: '销量',
    field: 'unitsOrdered',
    slots: {
      default: "unitsOrdered"
    },
    width: '80px',
    sortable: true,
    align: 'right',
    default: true,
    summary: true
  },
  {
    id: 'unitsOrderedB2b',
    title: '销量B2B',
    field: 'unitsOrderedB2b',
    width: '110px',
    sortable: true,
    align: 'right',
    summary: true
  },
  {
    id: 'orders',
    title: '订单量',
    field: 'orders',
    slots: {
      default: 'orders'
    },
    titleHelp: {
      message: "订单中存在多个商品时，合计栏不会重复统计"
    },
    width: '110px',
    sortable: true,
    align: 'right',
    default: true,
    summary: true
  },
  {
    id: 'orderProductSales',
    title: '销售额',
    field: 'orderProductSales',
    slots: {
      default: 'orderProductSales'
    },
    width: '100px',
    sortable: true,
    align: 'right',
    default: true,
    prefix: 'currencySymbol',
    summary: true,
  },
  {
    id: 'orderProductSalesB2b',
    title: '销售额B2B',
    field: 'orderProductSalesB2b',
    width: '110px',
    sortable: true,
    align: 'right',
    prefix: 'currencySymbol',
    summary: true,

  },
  {
    id: 'multiChannelOrders',
    title: '多渠道销量',
    field: 'multiChannelOrders',
    width: '100px',
    sortable: true,
    align: 'right',
    summary: true
  },
  {
    id: 'returns',
    title: '退货量',
    field: 'returns',
    minWidth: '85px',
    sortable: true,
    align: 'right',
    summary: true
  },
  {
    id: 'returnsRate',
    title: '退货率',
    field: 'returnsRate',
    width: '95px',
    sortable: true,
    align: 'right',
    titleHelp:{
      message:'退货率=退货量/销量；按订单退货时间统计'
    },
    suffix: '%',
    summary: true
  },
  {
    id: 'refunds',
    title: '退款量',
    field: 'refunds',
    minWidth: '85px',
    sortable: true,
    align: 'right',
    summary: true
  },
  {
    id: 'refundsRate',
    title: '退款率',
    field: 'refundsRate',
    minWidth: '95px',
    sortable: true,
    align: 'right',
    titleHelp:{
      message:'退款率=退款量/销量；按订单退款时间统计'
    },
    suffix: '%',
    summary: true
  },
  {
    id: 'returnProductSales',
    title: '退款销售额',
    field: 'returnProductSales',
    minWidth: '100px',
    sortable: true,
    align: 'right',
    prefix: 'currencySymbol',
    summary: true,
  },
  {
    id: 'avgUnitsOrderedSales',
    title: '平均订单价格',
    field: 'avgUnitsOrderedSales',
    minWidth: '135px',
    sortable: true,
    align: 'right',
    titleHelp:{
      message:'平均订单价格=销售额/订单量'
    },
    prefix: 'currencySymbol',
    summary: true,
  },
  {
    id: 'avgOrderItemsSales',
    title: '平均销售价格',
    field: 'avgOrderItemsSales',
    minWidth: '135px',
    sortable: true,
    align: 'right',
    titleHelp:{
      message:"平均销售价格=销售额/销量"
    },
    prefix: 'currencySymbol',
    summary: true,
  },
  {
    id: 'salesGrossProfit',
    title: '销售毛利',
    permission: 'cost:view',
    field: 'salesGrossProfit',
    width: '110px',
    sortable: true,
    align: 'right',
    prefix: 'currencySymbol',
    titleHelp:{
      message:'可到利润统计模块核算数据'
    },
    summary: true,
    default: true,
  },
  {
    id: 'grossProfitRate',
    title: '销售毛利率',
    permission: 'cost:view',
    field: 'grossProfitRate',
    width: '120px',
    sortable: true,
    align: 'right',
    titleHelp:{
      message:'销售毛利率=销售毛利/销售额'
    },
    suffix: '%',
    summary: true,
    default: true,
  },
  {
    id: 'salesNetProfit',
    title: '销售净毛利',
    permission: 'cost:view',
    field: 'salesNetProfit',
    width: '120px',
    sortable: true,
    align: 'right',
    prefix: 'currencySymbol',
    titleHelp:{
      message:"可到利润统计模块核算数据"
    },
    summary: true,
    default: true,
  },
  {
    id: 'salesNetProfitRate',
    title: '销售净毛利率',
    permission: 'cost:view',
    field: 'salesNetProfitRate',
    width: '130px',
    sortable: true,
    align: 'right',
    titleHelp:{
      message:"销售净毛利率=销售净毛利/销售额"
    },
    suffix: '%',
    summary: true,
    default: true,
  }
]
